/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PunchoutStatus = {
    WaitingToBeSent: 'WAITING_TO_BE_SENT',
    SentForValidation: 'SENT_FOR_VALIDATION',
    Accepted: 'ACCEPTED'
} as const;
export type PunchoutStatus = typeof PunchoutStatus[keyof typeof PunchoutStatus];


export function instanceOfPunchoutStatus(value: any): boolean {
    for (const key in PunchoutStatus) {
        if (Object.prototype.hasOwnProperty.call(PunchoutStatus, key)) {
            // @ts-ignore
            if (PunchoutStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PunchoutStatusFromJSON(json: any): PunchoutStatus {
    return PunchoutStatusFromJSONTyped(json, false);
}

export function PunchoutStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PunchoutStatus {
    return json as PunchoutStatus;
}

export function PunchoutStatusToJSON(value?: PunchoutStatus | null): any {
    return value as any;
}

